import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NotificationBellDotFilledSvg = function NotificationBellDotFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.902 4.087a7.09 7.09 0 0 0-2.111 5.04v4.434L2.5 18.092h19l-2.292-4.53V9.813a4 4 0 0 1-3.722-6.926 7.27 7.27 0 0 0-8.584 1.2M13.86 20.16V22h-3.72v-1.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3,
    fill: "#E23636"
  }));
};
export var NotificationBellDotFilled = function NotificationBellDotFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NotificationBellDotFilledSvg
  }));
};